// extracted by mini-css-extract-plugin
export default {"pivot":"MobileMenu_pivot__Iezkn","pivot-trigger":"MobileMenu_pivot-trigger__XMpz+","overlay":"MobileMenu_overlay__I2ul9"};